// extracted by mini-css-extract-plugin
export default {"subTitleBox":"Content_subTitleBox__sMp-D"};